var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"no-image"},[_c('v-icon',{attrs:{"disabled":""}},[_vm._v("mdi-image-outline")]),_c('v-icon',{staticClass:"icon-question",attrs:{"disabled":"","x-small":""}},[_vm._v("mdi-help")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }